module.exports = __webpack_public_path__ + "img/cnu_gallery7.0cd17721.jpg";